import type { ComponentMultiStyleConfig, SystemStyleObject } from '@chakra-ui/react';

const AlertComponentStyle: ComponentMultiStyleConfig = {
  parts: ['title', 'description', 'icon', 'container'],
  baseStyle: (props) => {
    const { status } = props;

    const statusStyles: Record<
      string,
      { container?: SystemStyleObject; title?: SystemStyleObject }
    > = {
      info: {
        container: {
          bg: 'primary100',
          color: 'primary600',
        },
      },
      error: {
        container: {
          bg: 'error100',
          color: 'error600',
        },
      },
      warning: {
        container: {
          bg: 'secondary100',
          color: 'secondary600',
        },
      },
    };

    return {
      container: {
        fontSize: {
          base: '16px',
          md: '18px',
        },
        borderRadius: 'md',
        ...statusStyles[status]?.container,
      },
      title: {
        fontFamily: 'Yorkten Slab',
        fontWeight: 'bold',
        ...statusStyles[status]?.title,
      },
      description: {
        fontFamily: 'Assistant',
      },
    };
  },
};

export default AlertComponentStyle;
